// @flow
// Import modules
import React from 'react';
import ClassNames from 'classnames';
import { Button } from '@riseart/common';
import { FormRadio, FormRadioGroup } from '@riseart/form';

// Import styles
import {
  quizQuestionCls,
  quizQuestionTextCls,
  quizQuestionButtonCls,
  quizQuestionButtonBackCls,
  quizQuestionButtonNextCls,
  quizQuestionOverlayCls,
  quizQuestionActiveCls,
} from './Question.less';

import { quizSingleSelectQuestionRadioCls } from './SingleSelect.less';

type Props = {
  text: string,
  options: Array<Object>,
  onChange: Function,
  backButton: {
    translationText: string,
    url: string,
    backListener: Function,
  },
  nextButton: {
    translationText: string,
    url: string,
    nextListener: Function,
  },
  isActive: boolean,
  isValid: boolean,
  id: string,
  type: string,
};

/**
 * Quiz Single Select Question
 *
 * @param {Props} props
 * @returns {XML}
 */
export const QuizSingleSelectQuestion = (props: Props) => {
  const tabIndex = props.isActive ? '0' : '-1';
  /**
   * handleChange
   * @param {Event} e
   */
  const handleChange = (e) => {
    const { id, type } = props;
    props.onChange({ id, type }, e.target.value);
  };

  return (
    <div
      className={ClassNames(quizQuestionCls, {
        [quizQuestionActiveCls]: props.isActive,
      })}
    >
      <div className={quizQuestionOverlayCls} />
      <div className={quizQuestionTextCls}>{props.text}</div>
      <div className={quizSingleSelectQuestionRadioCls}>
        <FormRadioGroup onChange={handleChange} size="small">
          {props.options.map((item) => (
            <FormRadio key={item.id} tabIndex={tabIndex} value={item.id}>
              {item.text}
            </FormRadio>
          ))}
        </FormRadioGroup>
      </div>
      <div className={quizQuestionButtonCls}>
        {props.backButton ? (
          <Button
            className={quizQuestionButtonBackCls}
            type="text"
            noBorder
            tabIndex={tabIndex}
            disabled={false}
            onClick={props.backButton.backListener}
          >
            {props.backButton.translationText}
          </Button>
        ) : null}

        {props.nextButton ? (
          <Button
            className={quizQuestionButtonNextCls}
            type="black"
            isBlackBorder
            tabIndex={tabIndex}
            disabled={!!props.isValid}
            onClick={props.nextButton.nextListener}
          >
            {props.nextButton.translationText}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
